import { Link } from "react-router-dom";
import Title from "../../components/pageTitle/Title";
import { issuesName_Src } from "./data";
import { useEffect, useState } from "react";
import MetaTags from "../../SEO/MetaTags";

export default function Issues_home() {
    const [ IssuesName_Src , setIssuesName_Src] = useState([])
    useEffect(()=>{
        setIssuesName_Src(issuesName_Src)
    },[issuesName_Src])

    const redirectToExternal = (number) => {
        window.location.href = `https://rmprs.com/index.php/rmprs/issue/view/${number}`;
    };
  return (

    <div className="content">
        <MetaTags title='إصدارات المجلة' description=' إصدارات المجلة المغربية لنشر الأبحاث العلمية'/>
        <Title title='إصدارات المجلة'/>
        <ul className="issues">
            {
                issuesName_Src.length == 0 ?
                    <p className="empty">ليس  هناك إصدارات  في المجلة</p>
                : (IssuesName_Src.slice(0,IssuesName_Src.length - 3).map((oneIssue, index) =>
                    <li key={index}>
                        <Link to={oneIssue.src}><h2>{oneIssue.title}</h2></Link>
                    </li>
                ))
            }
            <li>
                <a onClick={()=>redirectToExternal(10)}><h2>العدد العاشر</h2></a>
            </li>
            <li>
                <a onClick={()=>redirectToExternal(11)}><h2>العدد الحادي عشر</h2></a>
            </li>
            <li>
                <a onClick={()=>redirectToExternal(12)}><h2>العدد الثاني عشر</h2></a>
            </li>
            <li>
                <a onClick={()=>redirectToExternal(13)}><h2>العدد الثالث عشر</h2></a>
            </li>
            <li>
                <a onClick={()=>redirectToExternal(14)}><h2>العدد الرابع عشر</h2></a>
            </li>
            <li>
                <a onClick={()=>redirectToExternal(19)}><h2>العدد الخامس عشر</h2></a>
            </li>
            <li>
                <a onClick={()=>redirectToExternal(20)}><h2>العدد السادس عشر</h2></a>
            </li>
            <li>
                <a onClick={()=>redirectToExternal(21)}><h2>العدد السابع عشر</h2></a>
            </li>
            <li>
                <a onClick={()=>redirectToExternal(22)}><h2>العدد الثامن عشر</h2></a>
            </li>
            
            <li>
                <a onClick={()=>redirectToExternal(23)}><h2>العدد التاسع عشر</h2></a>
            </li>
            <li>
                <a onClick={()=>redirectToExternal(24)}><h2>العدد العشرين</h2></a>
            </li>
            <li>
                <a onClick={()=>redirectToExternal(25)}><h2>العدد الواحد و العشرون</h2></a>
            </li>
        </ul>
    </div>
  )
}